// @flow
import { CategoriasPOIActionTypes } from './constants';

type CategoriasPOIAction = { type: string, payload: {} | string };

// common success
export const categoriasPOIApiResponseSuccess = (actionType: string, data: any): CategoriasPOIAction => ({
    type: CategoriasPOIActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const categoriasPOIApiResponseError = (actionType: string, error: string): CategoriasPOIAction => ({
    type: CategoriasPOIActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getCategoriaPOI = (id: string): CategoriasPOIAction => ({
    type: CategoriasPOIActionTypes.GET_CATEGORIA_POI,
    payload: { id },
});

export const addCategoriaPOI = (categoriaPOI:any):CategoriasPOIAction=>({
    type:CategoriasPOIActionTypes.ADD_CATEGORIA_POI,
    payload:categoriaPOI
})
export const updateCategoriaPOI = (categoriaPOI:any):CategoriasPOIAction=>({
    type:CategoriasPOIActionTypes.UPDATE_CATEGORIA_POI,
    payload:categoriaPOI
})
export const deleteCategoriaPOI = (id:string):CategoriasPOIAction=>({
    type:CategoriasPOIActionTypes.DELETE_CATEGORIA_POI,
    payload:{id}
})

export const listCategoriasPOI = (params:any): CategoriasPOIAction => ({
    type: CategoriasPOIActionTypes.LIST_CATEGORIAS_POI,
    payload: params,
});


export const resetCategoriasPOI = (): CategoriasPOIAction => ({
    type: CategoriasPOIActionTypes.RESET,
    payload: {},
});

